import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-ui-loading-dialog',
  templateUrl: './ui-loading-dialog.component.html',
  styleUrls: ['./ui-loading-dialog.component.scss'],
})
export class UiLoadingDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data :{ title :string; message :string } | string,
  ) {}

  ngOnInit() :void {}

  get title() :string {
    if (this.data) {
      if (typeof this.data !== 'string') {
        return this.data?.title;
      }

      return this.data;
    }

    return '';
  }

  get message() :string {
    if (this.data) {
      if (typeof this.data !== 'string') {
        return this.data?.message;
      }
    }

    return '';
  }
}
